import { useMutation } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils.ts';
import useAuth from '../../hooks/useAuth.ts';

export default function useLockCampaignDetails() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({ teamId, campaignId, newState }: { teamId: string, campaignId: string, newState: 'locked' | 'unlocked' }) => {
      let path;

      if (newState === 'locked') {
        path = `team/${teamId}/campaign/${campaignId}/lock`;
      } else {
        path = `team/${teamId}/campaign/${campaignId}/unlock`;
      }

      return apiFetch<Response>({
        path,
        method: 'PUT',
        accessToken: String(tokens.accessToken),
      });
    },
  });
}
